import ApiResponse from "@core/types/apiResponse";
import { ApiMessageResponse } from "@core/types/apiMessageResponse";
import {
    FinanceAllocationRuleResponse,
    FinanceAllocationRuleKpi,
} from "@features/admin/finance/allocation-rule/types/financeAllocationRule";
import {
    CreateFinanceAllocationRuleRequest,
    UpdateFinanceAllocationRuleRequest,
} from "@features/admin/finance/allocation-rule/types/financeAllocationRuleRequests";
import {
    fetchAllocationRuleTemplateKpis,
    fetchFinanceAllocationRules,
    createFinanceAllocationRule,
    updateFinanceAllocationRule,
    disableFinanceAllocationRule,
    enableFinanceAllocationRule,
} from "@features/admin/finance/allocation-rule/api/financeAllocationRuleApi";

export const fetchAllocationRuleTemplateKpisAsync = async (
    nationId: number
): Promise<ApiResponse<FinanceAllocationRuleKpi[]>> => {
    return fetchAllocationRuleTemplateKpis(nationId);
};

export const fetchFinanceAllocationRulesAsync = async (
    nationId: number,
    params: any
): Promise<ApiResponse<FinanceAllocationRuleResponse>> => {
    const { nationId: _removed, ...filteredParams } = params || {};
    return fetchFinanceAllocationRules(nationId, filteredParams);
};

export const createFinanceAllocationRuleAsync = async (
    nationId: number,
    data: CreateFinanceAllocationRuleRequest
): Promise<ApiResponse<ApiMessageResponse>> => {
    return createFinanceAllocationRule(nationId, data);
};

export const updateFinanceAllocationRuleAsync = async (
    nationId: number,
    ruleGroupId: number,
    data: UpdateFinanceAllocationRuleRequest
): Promise<ApiResponse<ApiMessageResponse>> => {
    return updateFinanceAllocationRule(nationId, ruleGroupId, data);
};

export const disableFinanceAllocationRuleAsync = async (
    nationId: number,
    ruleGroupId: number
): Promise<ApiResponse<ApiMessageResponse>> => {
    return disableFinanceAllocationRule(nationId, ruleGroupId);
};

export const enableFinanceAllocationRuleAsync = async (
    nationId: number,
    ruleGroupId: number
): Promise<ApiResponse<ApiMessageResponse>> => {
    return enableFinanceAllocationRule(nationId, ruleGroupId);
};
